
  import {
    Component,
    Vue
  } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue'
  import {
    getProductSalesStatistics,
    productspecSellStatis
  } from '@/api/statistic';
	import{
		getSearchDate,
		nextDay
	} from "@/utils/index"

   let dt = new Date();
   let year = dt.getFullYear();
   let month = (dt.getMonth()+1) > 9 ? (dt.getMonth()+1) : ('0'+(dt.getMonth()+1));
   let day = dt.getDate() > 9 ? dt.getDate():('0'+dt.getDate());

  @Component({
    name: 'product-sales',
    components: {
      PageFooter
    }
  })



  export default class ProductSales extends Vue {
    private filterTime: any = []
    private productNameKey = ''
    private list: any = []
    private pageNo = 1;
    private pageSize = 10;
    private total = 0;
    private tableloading = false
    private lazyloading = false
		private totallist:any=[]

    mounted() {
			if(this.$route.params.time){
				this.filterTime = this.$route.params.time.split('/')
			}else{
				this.initTime()
			}
      this.getList();
    }

    
		private initTime(){
			this.filterTime = [getSearchDate(2,false,-30)[0],getSearchDate(2)[0]]
		}

    private changePage(num: number) {
      this.pageNo = num;
      this.getList();
    }


		private getrowkey(row){
			// console.log(row)
			return row.Id
		}

		private handleClickRow(scope:any) {
			// console.log(scope)
			if (scope.row.ProductId === '总计') return 
			// const $table: any = this.$refs.table
			// $table.toggleRowExpansion(scope.row)
			// scope.row.Open = !scope.row.Open
			if(scope.row.Open){
				this.$nextTick(()=>{
					const $table: any = this.$refs.table
					$table.toggleRowExpansion(scope.row)
					scope.row.Open = !scope.row.Open
				})
				return
			}
			this.getdetail(scope)
		}
    
		private async getdetail(scope){
			this.lazyloading = true
			try{
				let data:any = {
					ProductId:await scope.row.ProductId,
					SpecValue:scope.row.IsIncludedSubmitOrderInfo?scope.row.SpecValue:''
				}
				if (this.filterTime && this.filterTime.length) {
				data.StartTime = this.filterTime[0]
				data.EndTime = nextDay(this.filterTime[1],1);
			}
				let res = await productspecSellStatis(data)
				if(res.IsSuccess){
					// console.log(res.Result)
					this.list = this.list.map(v=>{
						if(v.ProductId==scope.row.ProductId&&scope.row.Id==v.Id){
							v.ProductSpecSellStatisList = res.Result.map(x=>{
								x.Id=v.ProductId+Math.random()+'child'
								x.IsMain = false
								x.ProductType = v.ProductType
								return x
							})
						}
						return v
					})
					this.$nextTick(()=>{
						const $table: any = this.$refs.table
						$table.toggleRowExpansion(scope.row)
						scope.row.Open = !scope.row.Open
					})
				}
			}finally{
				this.lazyloading = false
			}
		}

    
		private exportlist(){
			let url = location.origin + '/provider/product/sellStatisExport' + 
								'?Keywords=' + (this.productNameKey?this.productNameKey:'')

								if (this.filterTime && this.filterTime.length) {
									url += '&StartTime=' + (this.filterTime[0]?this.filterTime[0]:'')
									url += '&EndTime=' + (this.filterTime[1]?nextDay(this.filterTime[1],1):'');
								}
			// console.log(url)
			window.open(url)
		}

    private async getList() {
      let params: any = {
        // Skip: (this.pageNo-1)*this.pageSize,
        // Take: this.pageSize,
        Keywords: this.productNameKey
      }
      if (this.filterTime && this.filterTime.length) {
        params.StartTime = this.filterTime[0];
        params.EndTime = nextDay(this.filterTime[1],1);
      }
      this.tableloading = true
      try {
        const res: any = await getProductSalesStatistics(params);
        if(!res.Result.Result.Total){
					this.list = []
					this.total = 0
					this.totallist = []
					return 
				}
        let list = res.Result.Result.Results.map(v=>{
					v.IsOpen  = false
					v.Open = false
					v.IsMain = true
					v.Id=v.ProductId+Math.random()+'main'
					// v.ProductSpecSellStatisList = v.ProductSpecSellStatisList.map(x=>{
					// 	// x.IsOpen = false
					// 	x.Id=v.ProductId+Math.random()
					// 	return x
					// })
					return v
				})
				this.totallist = [{...res.Result.TotalStatistic,ProductId:'总计',IsMain:true,Id:'0main'}]
				this.list = list;
				// this.total = res.Result.Result.Total;
      }catch(e) {
        console.log(e)
      } finally{
        this.tableloading = false
      }
    }

    private doSearch() {
      this.pageNo = 1;
      this.getList();
    }

    private clearSearch() {
      // this.filterTime = [[year, month, '01'].join('-'), [year, month, day].join('-')];
      this.initTime()
      this.productNameKey = '';
      this.getList();
    }
  }
